/**

 *
 * Post
 *
 * Javascript events for the post single templat
 */

const $         = require( 'jQuery' );


    var PostUI = function(el){
        this.$el            = $(el);
        this.$mainNav       = $( document ).find( '#sticky-nav' );

        this.$sticky            = this.$el.find( '.itbl-c-sticky' );
        this.$mobileCats        = this.$el.find( '.itbl-c-post__blog-terms--mobile' );
        this.$searchContainer   = this.$el.find( '#toggle-search' );
        this.$searchToggleTrigger = this.$el.find( '#toggle-search-trigger span' );
        this.$postCatMobile     = this.$el.find( '#post-categories--mobile' );
        this.$postCatTrigger    = this.$el.find( '.itbl-c-post__categories-cta span' );

        this.init();
    };

    PostUI.prototype.init = function(){

        this.$postCatMobile
            .on( 'on.zf.toggler', (event)=>{

                this.$postCatTrigger
                    .addClass( 'transform-active' );

            } )
            .on( 'off.zf.toggler', (event)=> {

                this.$postCatTrigger
                    .removeClass( 'transform-active' )

            } );


    };

    PostUI.prototype.event__controlsStuck = function( event ){

        let menuHeight = this.$mainNav.outerHeight();
        const that = event.target;

        $( that ).css({
           'padding-top' :  menuHeight
        });

    };

    $(document).ready(function(){
        $('.itbl-c-post').each(function(){
            new PostUI(this);
        });

    });
